import styled from 'styled-components';

export const ChartSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
